import { render, staticRenderFns } from "./ProjectSummaryCard.vue?vue&type=template&id=33c3168a&scoped=true&"
import script from "./ProjectSummaryCard.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSummaryCard.vue?vue&type=style&index=0&id=33c3168a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c3168a",
  null
  
)

export default component.exports